@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row && $.row.type) {
    <i class="{{ getIconName($.row.type) }} mr-1"></i
    ><span>{{ $.row.type | titlecase }}</span>
  }
  @if ($.row && !$.row.type) {
    ...
  }
}
